import React from 'react';
import { PolarArea } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

const PolarAreaChart = ({data=[],labels=[],backgroundColors=[]}) => {
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: 'Total',
                data: data,
                backgroundColor: backgroundColors,
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
        },
    };

  return (
      <div style={{height: '60dvh',width:'60dvh'}}>
          <PolarArea data={chartData} options={options} />
      </div>
  )
}

export default PolarAreaChart